export default import.meta.ROLLDOWN_FILE_URL_jxa1mgLtTkWQsdf0ciZOLw